import { Component, OnInit, AfterContentInit } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ModalController} from "@ionic/angular";
import {FormLoginComponent} from "../../components/auth/form-login/form-login.component";
import {FormRegistrationComponent} from "../../components/auth/form-registration/form-registration.component";
import { TitleService } from './../../services/title.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss'],
})

export class LoginPage implements OnInit, AfterContentInit {
  contentLoaded = false;

  constructor(
    private readonly notificationService: NotificationService,
    private modalCtrl: ModalController,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private titleService: TitleService
  ) { }

  private readonly VAPID_PUBLIC_KEY = environment.webpushVapidKey;

  ngOnInit() {
    const { meta } = this.route.snapshot.data;
    this.titleService.setTitle(meta.title);

    if (this.auth.isAuthenticated) {
      this.router.navigate([`/${this.auth.defaultPage}`]).then();
    }
  }

  ngAfterContentInit() {
    this.contentLoaded = true;
  }

  async login() {
    this.notificationService.requestWebpushSubscriptionIfNot({ serverPublicKey: this.VAPID_PUBLIC_KEY });

    const modal = await this.modalCtrl.create({
      component: FormLoginComponent,
      id: 'FormLogin',
      cssClass: 'login-modal'
    });
    modal.present().then();
  }

  async registration() {
    this.notificationService.requestWebpushSubscriptionIfNot({ serverPublicKey: this.VAPID_PUBLIC_KEY });

    const modal = await this.modalCtrl.create({
      component: FormRegistrationComponent,
      cssClass: 'login-modal',
      id: 'FormRegistration'
    });
    modal.present().then();

    modal.onDidDismiss().then((dataReturned) => {
      console.log('FormRegistrationComponent hide');
    });
  }

  handleRefresh($event: any) {
    setTimeout(async () => {
      await this.ngOnInit();
      // location.reload();
      $event.target.complete();
    }, 2000);
  }
}
